import { render, staticRenderFns } from "./BankOrderList.vue?vue&type=template&id=210c2c47&"
import script from "./BankOrderList.vue?vue&type=script&lang=js&"
export * from "./BankOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports